<template>
  <v-dialog
    fullscreen
    hide-overlay
    v-model="dialog"
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false; elevatorId = null" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-container>
        <v-row class="content-data">
          <v-col>
            <iframe
              id="metabase-dashboard"
              :src="'https://statistic.gratis-notruf.com/public/dashboard/19ba5d5a-f147-4edb-91f5-32621d50a725?elevator_id=' + elevatorId"
              width="100%"
              height="100%"
              allowtransparency
            ></iframe>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "OfflineStats",
  data() {
    return {
      dialog: false,
      elevatorId: null
    }
  },
  methods: {
    initialization(item) {
      this.elevatorId = item.id;
      this.$nextTick(() => {
        this.dialog = true;
      });
    }
  }
}
</script>

<style>
  .content-data {
    height: 85vh;
  }
</style>
